//import { Container, Row, Col } from 'react-grid-system';
// import appStore from '../imgs/appStore.jpg';
// import googlePlay from '../imgs/googlePlay.jpg';

import useStore from '../../store/store';


const appStore = "https://uploads-ssl.webflow.com/6191b5ffff40d96697340a9c/6203cd029dacb4df12382855_appStore.5d56d653fce12c774526.png";
const googlePlay = "https://uploads-ssl.webflow.com/6191b5ffff40d96697340a9c/6203cd03198f01573f47060c_googlePlay.c043c58bcf6c970dc546.png";

const appStoreLink = "https://apps.apple.com/us/app/barrier-calculation-tool/id6444768183";
const googlePlayLink = "https://play.google.com/store/apps/details?id=maglabs.apps.mobile.soundPropagation";



const RightPanel = ({ resetOctavesValues }) => {
	//const showCalculations = useStore((state) => state.showCalculations)
	const setSourceHeight = useStore((state) => (state.setSourceHeight))
	const setReceiverHeight = useStore((state) => (state.setReceiverHeight));
	const setScenario = useStore((state) => (state.setScenario));
	const setGrid = useStore((state) => (state.setGrid));
	const setActivePanel = useStore((state) => (state.setActivePanel));
	const setActiveDBorOctavePanel = useStore((state) => (state.setActiveDBorOctavePanel));
	const setBarrier1 = useStore((state) => (state.setBarrier1));
	const setBarrier2 = useStore((state) => (state.setBarrier2));
	const setinitialMeasurementDistance = useStore((state) => (state.setinitialMeasurementDistance));
	const setinitialSoundNoise = useStore((state) => (state.setinitialSoundNoise));
	const setinitialSourceSoundPower = useStore((state) => (state.setinitialSourceSoundPower));

	function resetAllValues() {
		setScenario('noBarriers')
		setGrid('distance')
		setBarrier1({ height: 4, distance: 15 })
		setBarrier2({ height: 4, distance: 22.5 })
		setActivePanel('measured')
		setActiveDBorOctavePanel('measuredDB')
		setSourceHeight(2)
		setReceiverHeight(3)
		setinitialMeasurementDistance(10);
		setinitialSoundNoise(100);
		setinitialSourceSoundPower(96.8)
		resetOctavesValues();
	}

	return (
		<>
			<div className="panel" id="panel5">
				<div id='rightPanel'>
					<div className='panel-bold-title'>Options</div>
					<button onClick={() => resetAllValues()} className="action-button">Reset all values</button>
					<p style={{ marginBottom: '30px' }}>
						
						<b>The tool is now available as a mobile app.</b>
					</p>
					<div className='donwnloadApp'>
						<a target="_blank" rel="noreferrer"  href={appStoreLink}><img src={appStore} alt="toolTip" style={{  height: '30px', paddingLeft: '5px' }} /></a>
						<a target="_blank" rel="noreferrer"  href={googlePlayLink}><img src={googlePlay} alt="toolTip" style={{  height: '30px', paddingLeft: '5px' }} /></a>
					</div>
				</div>
			</div>
		</>
	);
}

export default RightPanel;